module.exports = __webpack_public_path__ + "static/media/lock.005e0667.svg";